import React from "react";
import useApp from "../../store/app/appContext";
import TreatmentsProvider from "../../store/treatments/treatmentsProvider";
import UsersProvider from "../../store/users/usersProvider";
import ClinicsProvider from "../../store/clinics/clinicsProvider";
import PageWrapper from "../../containers/app/PageWrapper";
import TreatmentTransactionCheckout from "../../containers/payments/CheckoutFlow";
import { useHistory } from "react-router-dom";

export default function TreatmentTransactionPaymentCheckout(props) {
  
  const {
    appState: { user },
  } = useApp();
  
  const history = useHistory();

  const state = props?.location?.state;

  if (!user) return "";
  if (!user._id) return "";
  if (!state) history.push("/dashboard");

  const { allTreatmentTransactions, treatmentInfo } = state;

  
  return (
    <TreatmentsProvider>
      <UsersProvider>
        <ClinicsProvider>
          <PageWrapper navbar title="Checkout">
            <TreatmentTransactionCheckout
              allTreatmentTransactions={allTreatmentTransactions}
              treatmentInfo={treatmentInfo}
            />
          </PageWrapper>
        </ClinicsProvider>
      </UsersProvider>
    </TreatmentsProvider>
  );
}